import { Navigate } from "react-router-dom";
import { useLoginContext } from "../context/Login_context";

const PrivateRoute = ({ children }) => {
  const { isLoggedIn, formStatus } = useLoginContext();

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  if (!formStatus) {
    return <Navigate to="/edit-profile" replace />;
  }

  return children;
};

export default PrivateRoute;
